import sortBy from "lodash/sortBy";

import type { TrafficShareMetricSchema } from "app/pages/benchmark-tracker/types/api.types";

export const createTrafficShareTableData = (
    primary: string,
    data: TrafficShareMetricSchema,
    domainImages: Record<string, string>,
) => {
    if (!data) {
        return [];
    }

    const { primaryData, competitorsData } = data;
    const competitors = Object.keys(competitorsData);
    const {
        share,
        shareTrend,
        periodOverPeriodShareDifference,
        yearOverYearShareDifference,
        rank,
        periodOverPeriodRankChange,
        yearOverYearRankChange,
    } = primaryData;

    const primaryTableData = {
        key: primary,
        domain: primary,
        trafficShare: share,
        pop: periodOverPeriodShareDifference,
        yoy: yearOverYearShareDifference,
        trends: shareTrend,
        rank: rank,
        defaultIcon: domainImages[primary],
        isPrimary: true,
        popRankChange: periodOverPeriodRankChange,
        yoyRankChange: yearOverYearRankChange,
    };

    const competitorsTableData = competitors.reduce<typeof primaryTableData[]>((acc, competitor) => {
        const data = competitorsData[competitor];
        const {
            share,
            shareTrend,
            periodOverPeriodShareDifference,
            yearOverYearShareDifference,
            rank,
            periodOverPeriodRankChange,
            yearOverYearRankChange,
        } = data;

        return [
            ...acc,
            {
                key: competitor,
                domain: competitor,
                trafficShare: share,
                pop: periodOverPeriodShareDifference,
                yoy: yearOverYearShareDifference,
                trends: shareTrend,
                rank: rank,
                defaultIcon: domainImages[competitor],
                isPrimary: false,
                popRankChange: periodOverPeriodRankChange,
                yoyRankChange: yearOverYearRankChange,
            },
        ];
    }, []);

    return sortBy([primaryTableData, ...competitorsTableData], "rank", "asc");
};
